import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const gbp = (n) => "£" + Number(n || 0).toFixed(2);

export default function ModelConfirmed() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const [booking, setBooking] = useState(null);
  useEffect(() => {
    if (!ref) return;
    api.get(`/bookings/by-reference/${ref}`).then((r) => setBooking(r.data)).catch(() => {});
  }, [ref]);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <p className="mono-label text-[10px] text-[#8A6D2A]">CLAÈ AESTHETICS</p>
        <h1 className="font-serif text-4xl mt-2">Model Appointment Confirmed</h1>
        <p className="mono-label text-[10px] mt-4 inline-block px-3 py-1 border border-emerald-300 bg-emerald-50 text-emerald-800">MODEL APPOINTMENT</p>
        {booking && (
          <div className="mt-6 border hairline p-6 text-left text-sm space-y-2">
            <p><span className="mono-label text-[10px] text-stone-500">CLIENT</span><br />{booking.client_name}</p>
            <p><span className="mono-label text-[10px] text-stone-500">TREATMENT</span><br />{(booking.items || []).map((i) => i.name).join(", ")}</p>
            <p><span className="mono-label text-[10px] text-stone-500">DATE / TIME</span><br />{booking.date} · {booking.time}</p>
            <p><span className="mono-label text-[10px] text-stone-500">DURATION</span><br />{booking.duration_min} min</p>
            <p><span className="mono-label text-[10px] text-stone-500">MODEL PRICE PAID</span><br /><span className="font-mono">{gbp(booking.model_price_applied || booking.total)}</span></p>
            {(booking.content_requirements || []).length > 0 && (
              <p><span className="mono-label text-[10px] text-stone-500">CONTENT REQUIRED</span><br />{(booking.content_requirements || []).join(", ")}</p>
            )}
            <p><span className="mono-label text-[10px] text-stone-500">REFERENCE</span><br /><span className="font-mono">{booking.reference}</span></p>
          </div>
        )}
        <p className="mt-6 text-xs text-stone-500">A confirmation email is on its way. Please check your inbox.</p>
        <Link to="/" className="mt-8 inline-block mono-label text-xs">RETURN HOME</Link>
      </div>
    </div>
  );
}
